import { Tooltip } from 'antd';
import React, { useContext, useState } from 'react';
import { ReactComponent as LightIcon } from "../../assets/image/Navbar/brightness-high.svg";
import { ReactComponent as DarkIcon } from "../../assets/image/Navbar/moon.svg";
import { ReactComponent as LogoutIcon } from '../../assets/image/Navbar/logout.svg';
import { AuthContext } from '../../auth/context/AuthContext';
import { ConfigGeneralContext } from '../../auth/context/ConfigGeneral/ConfigGeneralContext';

export default function Navbar({ userEmail }) {
  const { signOut, User } = useContext(AuthContext);
  const [darkMode, setDarkMode] = useState(true);
  const { getDataMode } = useContext(ConfigGeneralContext)

  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    getDataMode(newMode ? 'dark' : 'light')
    sessionStorage.setItem('mode', newMode ? 'dark' : 'light');
  };

  const logOut = async (e) => {
    signOut();
  };

  return (
    <nav className={`flex justify-end items-center w-full px-10 py-4 bg-nc-gray text-white`}>
      <div className="flex items-center">
        <span className="mr-4">{userEmail}</span>

        <Tooltip title={`Switch to ${darkMode ? "Light" : "Dark"} Mode`}>
          <button
            onClick={toggleDarkMode}
            className="flex items-center mr-4"
          >
            {darkMode ? <LightIcon /> : <DarkIcon />}
          </button>
        </Tooltip>

        <Tooltip title="Log Out">
          <button
            onClick={() => logOut()}
            className="flex items-center"
          >
            <LogoutIcon />
          </button>
        </Tooltip>
      </div>
    </nav>
  );
}